/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-ts 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { Method, RequestBodyType, ResponseBodyType, RequestConfig, RequestFunctionRestArgs, FileData, prepare } from '@bigo/yapi-to-ts'
// @ts-ignore
import request from './request'
// @ts-ignore
import makeRequestHook from './makeRequestHook'

// makeRequest
function makeRequest<TReqeustData, TResponseData>(requestConfig) {
  const req = function (requestData?: TReqeustData, options?: Record<string, any>) {
    return request<TResponseData>(prepare(Object.assign(requestConfig, options), requestData))
  }
  req.requestConfig = requestConfig
  return req
}

const mockUrl_3_0_0_0 = 'http://yapi.ppx520.com/mock/6645' as any
const dataKey_3_0_0_0 = 'data' as any

export interface LiveGameRouletteBatchGetTbhQuestions6645Request {
  _yy_from?: string
  seqid?: number
  uid?: number
  roomid?: string
  cursor?: string
  page_size?: number
}

export interface LiveGameRouletteBatchGetTbhQuestions6645Response {
  seqid: number
  res: number
  count: number
  next_cursor: string
  questions: []
}
type LiveGameRouletteBatchGetTbhQuestions6645RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/6645',
    '/bigolive/live_game_roulette/BatchGetTbhQuestions',
    'data',
    string,
    string,
    false
  >
>

const liveGameRouletteBatchGetTbhQuestions6645RequestConfig = {
  mockUrl: mockUrl_3_0_0_0,
  path: '/bigolive/live_game_roulette/BatchGetTbhQuestions',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {
    'X-Auth-Token':
      'BAAAAC22So0u6I4u48xm2P51uLbLIm8kYbQC7T3ACGonQ38628KSDdre6BO8573ddyIv0AbXsjalL09vjhjBW980t81H50R9bsn3fnjvB',
  },
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_3_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveGameRouletteBatchGetTbhQuestions6645',
}

export const liveGameRouletteBatchGetTbhQuestions6645 = makeRequest<
  LiveGameRouletteBatchGetTbhQuestions6645Request,
  LiveGameRouletteBatchGetTbhQuestions6645Response
>(liveGameRouletteBatchGetTbhQuestions6645RequestConfig)
export const useLiveGameRouletteBatchGetTbhQuestions6645 = makeRequestHook<
  LiveGameRouletteBatchGetTbhQuestions6645Request,
  LiveGameRouletteBatchGetTbhQuestions6645RequestConfig,
  ReturnType<typeof liveGameRouletteBatchGetTbhQuestions6645>
>(liveGameRouletteBatchGetTbhQuestions6645)

export interface LiveGameRouletteUpdateTbhQuestion6645Request {
  _yy_from?: string
  seqid?: number
  roomid?: string
  qid?: string
  content?: string
}

export interface LiveGameRouletteUpdateTbhQuestion6645Response {}
type LiveGameRouletteUpdateTbhQuestion6645RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/6645',
    '/bigolive/live_game_roulette/UpdateTbhQuestion',
    'data',
    string,
    string,
    false
  >
>

const liveGameRouletteUpdateTbhQuestion6645RequestConfig = {
  mockUrl: mockUrl_3_0_0_0,
  path: '/bigolive/live_game_roulette/UpdateTbhQuestion',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_3_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveGameRouletteUpdateTbhQuestion6645',
}

export const liveGameRouletteUpdateTbhQuestion6645 = makeRequest<
  LiveGameRouletteUpdateTbhQuestion6645Request,
  LiveGameRouletteUpdateTbhQuestion6645Response
>(liveGameRouletteUpdateTbhQuestion6645RequestConfig)
export const useLiveGameRouletteUpdateTbhQuestion6645 = makeRequestHook<
  LiveGameRouletteUpdateTbhQuestion6645Request,
  LiveGameRouletteUpdateTbhQuestion6645RequestConfig,
  ReturnType<typeof liveGameRouletteUpdateTbhQuestion6645>
>(liveGameRouletteUpdateTbhQuestion6645)

export interface LiveGameRouletteDeleteTbhQuestion6645Request {
  _yy_from?: string
  seqid?: number
  roomid?: string
  qid?: string
}

export interface LiveGameRouletteDeleteTbhQuestion6645Response {}
type LiveGameRouletteDeleteTbhQuestion6645RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/6645',
    '/bigolive/live_game_roulette/DeleteTbhQuestion',
    'data',
    string,
    string,
    false
  >
>

const liveGameRouletteDeleteTbhQuestion6645RequestConfig = {
  mockUrl: mockUrl_3_0_0_0,
  path: '/bigolive/live_game_roulette/DeleteTbhQuestion',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_3_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveGameRouletteDeleteTbhQuestion6645',
}

export const liveGameRouletteDeleteTbhQuestion6645 = makeRequest<
  LiveGameRouletteDeleteTbhQuestion6645Request,
  LiveGameRouletteDeleteTbhQuestion6645Response
>(liveGameRouletteDeleteTbhQuestion6645RequestConfig)
export const useLiveGameRouletteDeleteTbhQuestion6645 = makeRequestHook<
  LiveGameRouletteDeleteTbhQuestion6645Request,
  LiveGameRouletteDeleteTbhQuestion6645RequestConfig,
  ReturnType<typeof liveGameRouletteDeleteTbhQuestion6645>
>(liveGameRouletteDeleteTbhQuestion6645)

export interface LiveGameRouletteStartTbhGame6645Request {
  _yy_from?: string
  seqid?: number
  roomid?: string
  question_type?: number
  join_uids?: number[]
}

export interface LiveGameRouletteStartTbhGame6645Response {
  res: number
}
type LiveGameRouletteStartTbhGame6645RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/6645',
    '/bigolive/live_game_roulette/StartTbhGame',
    'data',
    string,
    string,
    false
  >
>

const liveGameRouletteStartTbhGame6645RequestConfig = {
  mockUrl: mockUrl_3_0_0_0,
  path: '/bigolive/live_game_roulette/StartTbhGame',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_3_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveGameRouletteStartTbhGame6645',
}

export const liveGameRouletteStartTbhGame6645 = makeRequest<
  LiveGameRouletteStartTbhGame6645Request,
  LiveGameRouletteStartTbhGame6645Response
>(liveGameRouletteStartTbhGame6645RequestConfig)
export const useLiveGameRouletteStartTbhGame6645 = makeRequestHook<
  LiveGameRouletteStartTbhGame6645Request,
  LiveGameRouletteStartTbhGame6645RequestConfig,
  ReturnType<typeof liveGameRouletteStartTbhGame6645>
>(liveGameRouletteStartTbhGame6645)

export interface LiveGameRouletteEndTbhGame6645Request {
  _yy_from?: string
  seqid?: number
  roomid?: string
}

export interface LiveGameRouletteEndTbhGame6645Response {}
type LiveGameRouletteEndTbhGame6645RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/6645',
    '/bigolive/live_game_roulette/EndTbhGame',
    'data',
    string,
    string,
    false
  >
>

const liveGameRouletteEndTbhGame6645RequestConfig = {
  mockUrl: mockUrl_3_0_0_0,
  path: '/bigolive/live_game_roulette/EndTbhGame',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_3_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveGameRouletteEndTbhGame6645',
}

export const liveGameRouletteEndTbhGame6645 = makeRequest<
  LiveGameRouletteEndTbhGame6645Request,
  LiveGameRouletteEndTbhGame6645Response
>(liveGameRouletteEndTbhGame6645RequestConfig)
export const useLiveGameRouletteEndTbhGame6645 = makeRequestHook<
  LiveGameRouletteEndTbhGame6645Request,
  LiveGameRouletteEndTbhGame6645RequestConfig,
  ReturnType<typeof liveGameRouletteEndTbhGame6645>
>(liveGameRouletteEndTbhGame6645)

export interface LiveGameRouletteSelectedTbhOnlineUser6645Request {
  _yy_from?: string
  seqid?: number
  selected_uid?: number
  roomid?: string
  ext?: {
    questions?: string
    gameid?: string
    sessionid?: string
  }
}

export interface LiveGameRouletteSelectedTbhOnlineUser6645Response {}
type LiveGameRouletteSelectedTbhOnlineUser6645RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/6645',
    '/bigolive/live_game_roulette/SelectedTbhOnlineUser',
    'data',
    string,
    string,
    false
  >
>

const liveGameRouletteSelectedTbhOnlineUser6645RequestConfig = {
  mockUrl: mockUrl_3_0_0_0,
  path: '/bigolive/live_game_roulette/SelectedTbhOnlineUser',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_3_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveGameRouletteSelectedTbhOnlineUser6645',
}

export const liveGameRouletteSelectedTbhOnlineUser6645 = makeRequest<
  LiveGameRouletteSelectedTbhOnlineUser6645Request,
  LiveGameRouletteSelectedTbhOnlineUser6645Response
>(liveGameRouletteSelectedTbhOnlineUser6645RequestConfig)
export const useLiveGameRouletteSelectedTbhOnlineUser6645 = makeRequestHook<
  LiveGameRouletteSelectedTbhOnlineUser6645Request,
  LiveGameRouletteSelectedTbhOnlineUser6645RequestConfig,
  ReturnType<typeof liveGameRouletteSelectedTbhOnlineUser6645>
>(liveGameRouletteSelectedTbhOnlineUser6645)

export interface LiveGameRouletteQryUserCurrentTbhGameInfo6645Request {
  _yy_from?: string
  seqid?: number
  roomid?: string
  user_keys?: string[]
  ext?: {
    qry_question_type_only?: string
  }
}

export interface LiveGameRouletteQryUserCurrentTbhGameInfo6645Response {
  seqid: number
  res: number
  question_type: number
  question_num_limit: number
  uid_all_info: []
}
type LiveGameRouletteQryUserCurrentTbhGameInfo6645RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/6645',
    '/bigolive/live_game_roulette/QryUserCurrentTbhGameInfo',
    'data',
    string,
    string,
    false
  >
>

const liveGameRouletteQryUserCurrentTbhGameInfo6645RequestConfig = {
  mockUrl: mockUrl_3_0_0_0,
  path: '/bigolive/live_game_roulette/QryUserCurrentTbhGameInfo',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_3_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'liveGameRouletteQryUserCurrentTbhGameInfo6645',
}

export const liveGameRouletteQryUserCurrentTbhGameInfo6645 = makeRequest<
  LiveGameRouletteQryUserCurrentTbhGameInfo6645Request,
  LiveGameRouletteQryUserCurrentTbhGameInfo6645Response
>(liveGameRouletteQryUserCurrentTbhGameInfo6645RequestConfig)
export const useLiveGameRouletteQryUserCurrentTbhGameInfo6645 = makeRequestHook<
  LiveGameRouletteQryUserCurrentTbhGameInfo6645Request,
  LiveGameRouletteQryUserCurrentTbhGameInfo6645RequestConfig,
  ReturnType<typeof liveGameRouletteQryUserCurrentTbhGameInfo6645>
>(liveGameRouletteQryUserCurrentTbhGameInfo6645)

export interface BigoDbQryGetUserInfoFromServer6645Request {
  _yy_from?: string
  /**
   * 填写时请进行类型范围校验，不要传超出范围的值
   */
  seq_id?: number
  my_uid?: number
  app_id?: number
  /**
   * size不能超过500
   */
  uids?: number[]
  /**
   * wiki中拿对应key名字去搜索即可
   */
  other_attr?: string[]
}

export interface BigoDbQryGetUserInfoFromServer6645Response {
  _yy_from: string
  my_uid: number
  app_id: number
  seq_id: number
  user_info: {
    '1600026181': {
      _yy_from: string
      version: number
      other_attr_val: {
        data1: string
        user_cover: string
        nick_name: string
      }
    }
  }
  res_code: number
}
type BigoDbQryGetUserInfoFromServer6645RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/6645',
    '/bigolive/bigo_db_qry/GetUserInfoFromServer',
    'data',
    string,
    string,
    false
  >
>

const bigoDbQryGetUserInfoFromServer6645RequestConfig = {
  mockUrl: mockUrl_3_0_0_0,
  path: '/bigolive/bigo_db_qry/GetUserInfoFromServer',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_3_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'bigoDbQryGetUserInfoFromServer6645',
}

export const bigoDbQryGetUserInfoFromServer6645 = makeRequest<
  BigoDbQryGetUserInfoFromServer6645Request,
  BigoDbQryGetUserInfoFromServer6645Response
>(bigoDbQryGetUserInfoFromServer6645RequestConfig)
export const useBigoDbQryGetUserInfoFromServer6645 = makeRequestHook<
  BigoDbQryGetUserInfoFromServer6645Request,
  BigoDbQryGetUserInfoFromServer6645RequestConfig,
  ReturnType<typeof bigoDbQryGetUserInfoFromServer6645>
>(bigoDbQryGetUserInfoFromServer6645)

export interface BigoDbQryGetUserLocPws6645Request {
  uids: number[]
  keys: string[]
  _yy_from: string
  app_id: number
  seq_id: number
}

export interface BigoDbQryGetUserLocPws6645Response {}
type BigoDbQryGetUserLocPws6645RequestConfig = Readonly<
  RequestConfig<
    'http://yapi.ppx520.com/mock/6645',
    '/bigolive/bigo_db_qry/GetUserLoc_PWS',
    'data',
    string,
    string,
    false
  >
>

const bigoDbQryGetUserLocPws6645RequestConfig = {
  mockUrl: mockUrl_3_0_0_0,
  path: '/bigolive/bigo_db_qry/GetUserLoc_PWS',
  isYapi: true,
  isC: true,
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_3_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'bigoDbQryGetUserLocPws6645',
}

export const bigoDbQryGetUserLocPws6645 = makeRequest<
  BigoDbQryGetUserLocPws6645Request,
  BigoDbQryGetUserLocPws6645Response
>(bigoDbQryGetUserLocPws6645RequestConfig)
export const useBigoDbQryGetUserLocPws6645 = makeRequestHook<
  BigoDbQryGetUserLocPws6645Request,
  BigoDbQryGetUserLocPws6645RequestConfig,
  ReturnType<typeof bigoDbQryGetUserLocPws6645>
>(bigoDbQryGetUserLocPws6645)

/* prettier-ignore-end */
